import { Injectable } from '@angular/core';
import { CtAuthenticationGuard, CtAuthenticationService } from '@ctsolution/ct-authentication';

@Injectable({
  providedIn: 'root'
})
export class ClaimsService {


  constructor (private _auth: CtAuthenticationService,private _CTAuthenticationGuard : CtAuthenticationGuard){}

  async getEnabledTest() : Promise<boolean>{

    await this._auth.getClaims();
    await this._auth.claimsUploaded();
    return this._CTAuthenticationGuard.userHasRole(['SELLER']);

  }


}
